<template>
  <b-row class="w-100">
    <b-col
      :md="index === fields.length - 1 ? '5': ''"
      v-for="(input, index) in fields"
      :key="`${index}${input.name}`"
      class="mb-2">
      <div class="d-flex align-items-center">
        <label :for="input.name" class="pr-0 mb-0 text-uppercase">{{input.label}}</label>
        <div class="d-flex align-items-center">
          <label class="switch switch-3d switch-success mb-0 ml-2" :class="{'disabled': disable(input.name)}">
            <b-form-checkbox type="checkbox"
                             class="switch-input"
                             v-model="params[input.name]"
                             @change="value => {!disable(input.name) ? debounceSendRequest(input.name, value) : ''}"
            />
            <input type="checkbox"
                   class="switch-input"
                   :checked="params[input.name]"
            >
            <span class="switch-slider"></span>
          </label>
          <span v-if="input.title && params[input.name]"
                class="d-inline text-success pl-2">{{input.title}}</span>
          <span v-if="input.title && !params[input.name]"
                class="d-inline text-muted pl-2">{{input.titleFalse}}</span>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
  export default {
    name: 'Switchers',
    props: {
      fields: {
        type: Array,
        require: true
      },
      prefillParams: {
        type: Object
      },
    },
    computed: {
      id() {
        return this.$route.params.id
      }
    },
    data() {
      return {
        params: {},
        debounceSendRequest: () => {
        }
      }
    },
    created() {
      if (!!this.prefillParams) {
        this.params = this.prefillParams;
      }
      this.debounceSendRequest = _.debounce(this.sendRequest, 500);
    },
    methods: {
      createParamsObject() {
        this.$forceUpdate()
      },
      sendRequest(name, value) {
        let params = {
          settings: {}
        };
        params.locked = this.params.locked;
        params.settings.never_lock = this.params.never_lock;
        params.settings.never_compromised = this.params.never_compromised;
        if (name === 'locked') {
          params.locked = value;
        } else {
          params.settings[name] = value
        }
        this.$forceUpdate();
        this.putData(`users/${this.id}`, params)
      },
      disable(name) {
        if (name === 'locked' && this.params.never_lock) {
          this.params.locked = false;
          return true
        } else {
          return false
        }
      }
    }
  }
</script>